import { getPermissions, UserPermissions } from '@creditsights/api-ui-web';
import { useQuery } from 'react-query';
import { queryKeys } from '../queryKeyFactory';

interface useFetchUserPermissionsResult {
  data?: UserPermissions;
  isLoading: boolean;
  isError: boolean;
  isFetched: boolean;
}

export default (isAuthenticated = true): useFetchUserPermissionsResult => {
  const { data, isLoading, isError, isFetched } = useQuery<UserPermissions, Error>(
    [queryKeys.fetchContentTypePermissions],
    async () => {
      return getPermissions();
    },
    {
      enabled: isAuthenticated,
    }
  );
  return { data, isLoading, isError, isFetched };
};
